import { deburrComprehensive } from './deburr';

const UNICODE_RE = /(?:\p{L}|\p{M}|\p{N}|\p{S}|\u{FE0F}|\u{200D})+/gu;
const ASCII_RE = /[a-zA-Z0-9\u20AC]+/g;

function hasUnicodeWord(str: string): boolean {
  return /[^\u0020-\u007F]/.test(str);
}

function preprocess(str: string): string {
  return str
    .replace(/[\u{00A3}\u{00A5}]/gu, ' ')
    .replace(/(\u{20AC})/gu, ' $1 ')
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .replace(/([A-Z]+)([A-Z][a-z])/g, '$1 $2');
}

function words(str: string): string[] {
  const withSpaces = preprocess(str);
  const regex = hasUnicodeWord(str) ? UNICODE_RE : ASCII_RE;
  return withSpaces.match(regex) || [];
}

/*
 ** Convert a string to kebab-case
 ** This function is a replacement port of lodash.kebabCase due to some edge cases with charSet incompatibilities
 ** in the lodash implementation.
 */
export const kebabCase = (input: string): string => {
  const deburred = deburrComprehensive(input);
  const withoutApos = deburred.replace(/[\u{2018}\u{2019}']/gu, '');
  return words(withoutApos)
    .map(w => w.toLowerCase())
    .join('-');
};
